import { Component } from '@angular/core';
import { values } from 'lodash';
@Component({
  selector: 'kt-deliver-to',
  templateUrl: './deliver-to.component.html',
  styleUrls: ['./deliver-to.component.scss'],
})
export class DeliverToComponent {
  listCountries = [
    { id: 0, name: 'VN', value: 'vn', imgPath: '/assets/media/Image/vn.png' },
    { id: 1, name: 'CN', value: 'cn', imgPath: '/assets/media/Image/cn.png' },
    { id: 2, name: 'EN', value: 'en', imgPath: '/assets/media/Image/america.png' },
  ];

  selectedCountryId = 0;

  OnInit() {}
  onCountryChange(id: number) {
    this.selectedCountryId = id;
  }
}
